import { RcFile } from 'antd/lib/upload';
import { ImageUploadProps } from 'enums/CreateProductModalEnums';
import { ProductModalFormValue } from '.';
import { FormikErrors } from 'formik';

export const validateProductModal = (values: ProductModalFormValue, image?: RcFile) => {
  const {
    ml: unit,
    productNetWeight,
    productGrossWeight,
    productDensity,
  } = values;
  const errors: FormikErrors<ProductModalFormValue> = {};
  let isValidWeight;

  if (!image) {
    errors.image = ImageUploadProps.IMAGE_REQUIRED;
  }

  const productNetWeightConverted = parseFloat(productNetWeight as unknown as string);
  const productGrossWeightConverted = parseFloat(productGrossWeight as unknown as string);
  const productDensityConverted = parseFloat(productDensity as unknown as string);

  switch (unit) {
    case 'kg':
      isValidWeight =
        productNetWeightConverted * 1000 <= productGrossWeightConverted;
      break;

    case 'g':
      isValidWeight = productNetWeightConverted <= productGrossWeightConverted;
      break;

    case 'ml':
      isValidWeight =
        productNetWeightConverted * productDensityConverted <=
        productGrossWeightConverted;
      break;

    case 'L':
      isValidWeight =
        productNetWeightConverted * 1000 <= productGrossWeightConverted;
      break;
  }

  if (!isValidWeight) {
    errors.productNetWeight =
      'Product net weight should be less than gross weight';
  }

  return errors;
}; 